import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div className="card" style={{ maxWidth: 480, width: '100%' }}>
            <div className="card-body">
              <div className="empty-state">
                <AlertTriangle className="es-icon" size={48} color="var(--red-500)" />
                <h3>Something went wrong</h3>
                <p>{this.state.error?.message || 'An unexpected error occurred.'}</p>
                <button className="btn btn-primary" onClick={this.handleReload} style={{ marginTop: 16 }}>
                  <RefreshCw size={14} /> Reload page
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
